<template>
  <div>
    <v-dialog
      v-model="productHoldDialog"
      max-width="900px"
      persistent
      scrollable
    >
      <v-card class="product-hold-card">
        <div class="product-hold-header">
          <div class="header-icon">
            <v-icon color="#fddf00" size="32">event_busy</v-icon>
          </div>
          <div class="header-content">
            <h2 class="header-title">Close Product</h2>
            <p class="header-subtitle">
              <span v-if="selectedHoldProduct">
                {{ selectedHoldProduct.product_name_th || "" }}
                <span v-if="selectedHoldProduct.product_code">
                  ({{ selectedHoldProduct.product_code }})
                </span>
              </span>
              <span v-else>
                Hold a product for a specific day (call center)
              </span>
            </p>
          </div>

          <v-btn
            icon
            :disabled="holdSubmitting || holdRemoving"
            @click="closeHoldDialog"
            class="close-btn"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <v-progress-linear
          v-if="holdLoading"
          indeterminate
          color="primary"
          height="3"
        />

        <v-divider></v-divider>

        <v-card-text class="product-hold-content">
          <div class="hold-grid">
            <div class="hold-section">
              <div class="section-header">
                <h4 class="section-title">
                  <v-icon color="#fddf00" class="mr-2">event</v-icon>
                  Close for a day
                </h4>
              </div>

              <v-alert type="info" outlined class="mb-3">
                Close this product for a specific day (call center).
              </v-alert>

              <v-menu
                ref="holdDateMenu"
                v-model="holdDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="holdForm.hold_date"
                  label="Hold date"
                  outlined
                  color="#fddf00"
                  readonly
                  :disabled="holdSubmitting"
                  class="form-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="#fddf00" size="20">event</v-icon>
                  </template>
                </v-text-field>
                <v-date-picker
                  v-model="holdForm.hold_date"
                  @input="holdDateMenu = false"
                  no-title
                  color="primary"
                />
              </v-menu>

              <v-text-field
                v-model="holdForm.reason"
                label="Reason"
                outlined
                color="#fddf00"
                :disabled="holdSubmitting"
                class="form-field"
                placeholder="Call center note / reason"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="#fddf00" size="20">notes</v-icon>
                </template>
              </v-text-field>

              <v-btn
                block
                color="#fddf00"
                class="action-btn hold-btn elevation-0"
                :loading="holdSubmitting"
                :disabled="holdSubmitting || !selectedHoldProduct"
                @click="submitHold"
              >
                <v-icon class="mr-2">event_busy</v-icon>
                Close for this date
              </v-btn>
            </div>

            <div class="hold-section">
              <div class="section-header section-header-row">
                <h4 class="section-title">
                  <v-icon color="#fddf00" class="mr-2">history</v-icon>
                  Hold history
                </h4>
                <v-btn
                  small
                  outlined
                  color="#fddf00"
                  class="refresh-btn"
                  :loading="holdLoading"
                  :disabled="holdLoading || !selectedHoldProduct"
                  @click="refreshHolds"
                  icon
                >
                  <v-icon small>refresh</v-icon>
                </v-btn>
              </div>

              <v-switch
                v-model="showInactiveHolds"
                label="Show inactive"
                class="mt-0"
                hide-details
                :disabled="holdLoading"
              />

              <v-divider class="my-2" />

              <div
                v-if="!holdLoading && productHolds.length === 0"
                class="text-xs-center py-4 grey--text"
              >
                No holds found
              </div>

              <v-list two-line dense v-else class="hold-history-list">
                <v-list-tile
                  v-for="hold in productHolds"
                  :key="hold.product_hold_id"
                  class="hold-history-item"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ hold.start_date }}
                      <span
                        v-if="
                          hold.end_date && hold.end_date !== hold.start_date
                        "
                      >
                        - {{ hold.end_date }}
                      </span>
                      <span
                        class="ml-2"
                        :style="{ color: hold.is_active ? 'green' : 'grey' }"
                      >
                        {{ hold.is_active ? "Active" : "Inactive" }}
                      </span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ hold.reason || "-" }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn
                      icon
                      color="red"
                      :disabled="
                        !hold.is_active ||
                        holdRemovingIds[hold.product_hold_id] === true
                      "
                      :loading="holdRemovingIds[hold.product_hold_id] === true"
                      @click="removeHold(hold)"
                    >
                      <v-icon color="white">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="hideActionsTable" :timeout="0" :multi-line="true">
      Sort data
      <v-card-actions v-if="sort_data == true">
        <v-btn
          @click="cancelSortData()"
          :loading="cancel_sort"
          :disabled="cancel_sort || sorting_data || fetching"
          color="red"
          dark
          >Cancel</v-btn
        >
        <!-- v-if="sort_data == true" -->
        <v-btn
          @click="saveSort()"
          :loading="sorting_data"
          :disabled="sorting_data || cancel_sort || fetching"
          color="green"
          dark
          >Apply sort</v-btn
        >
        <label v-if="sort_msg == 3">Can't sort</label>
        <!-- v-else-if="sort_data == true" -->
      </v-card-actions>
    </v-snackbar>
    <h1 class="text-pagename">
      Product list {{ store_name != null ? " in " + store_name : null }}
    </h1>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      :to="
        '/weserve_admin_login/control/' +
        $store.state.backOffice.province +
        '/storeandproduct/store/' +
        $store.state.storeBack.store_detail_id +
        '/product/-1/id/0'
      "
      @click="toAdd()"
      v-if="sort_data == false && !isEditProductList"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <storeProductForm
      :dialog="productDialog"
      @setDialog="productDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :form="form"
      @addProduct="addProduct()"
      :original_data="original_data"
      :fetching_data="fetching_data"
      @setFetchingData="fetching_data = $event"
      @fetchData="fetching = $event"
    />
    <v-layout row wrap v-if="sort_data == false">
      <v-flex xs6 class="text-xs-left">
        <v-toolbar dense flat>
          <v-btn
            @click="startSort()"
            v-if="sort_data == false && !isEditProductList"
            :disabled="
              search != '' ||
              selected_type != 0 ||
              fetching ||
              search_by_status != 99
            "
            round
            dark
            >Start sort</v-btn
          >
        </v-toolbar>
      </v-flex>
      <v-flex xs6>
        <v-toolbar dense flat>
          <v-flex xs8>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Name / Price / Approve status"
              single-line
              hide-details
              style="padding: 0"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-select
              prepend-icon="search"
              label="Product status"
              v-model="search_by_status"
              item-text="name"
              item-value="value"
              :items="[
                { name: 'All', value: 99 },
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
              ]"
            ></v-select>
          </v-flex>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-card class="mx-2 mt-2">
      <v-card-text>
        <v-layout row wrap class="text-xs-left">
          <v-btn
            :disabled="
              sorting_data || cancel_sort || selected_type == 0 || fetching
            "
            color="primary"
            class="black--text"
            @click="filterType(0)"
            >All</v-btn
          >
          <draggable
            :list="product_type_list"
            :disabled="!sort_data"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
          >
            <v-btn
              :disabled="
                sorting_data ||
                cancel_sort ||
                selected_type == info.product_type_id ||
                fetching
              "
              v-for="info in product_type_list"
              :key="info.product_type_id"
              @click="filterType(info.product_type_id)"
            >
              <v-icon v-if="sort_data == true">drag_indicator</v-icon>
              {{ info.product_type_name_th }}
            </v-btn>
          </draggable>
        </v-layout>
      </v-card-text>
      <v-divider v-if="sort_data == true" />
    </v-card>
    <v-data-table
      :loading="fetching"
      :search="search"
      :headers="headers"
      :items="filterdProduct"
      :hide-actions="hideActionsTable"
      :pagination.sync="pagination"
    >
      <!-- product_list -->
      <template slot="items" slot-scope="props">
        <td class="px-1 handle" style="width: 0.1%" v-if="sort_data == true">
          <v-btn style="cursor: move" icon :disabled="sorting_data">
            <v-icon>drag_indicator</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center" v-else>{{ countIndex(props.item) }}</td>
        <td class="text-xs-center">{{ props.item.product_code }}</td>
        <td style="padding: 6px 0 0 0; position: relative">
          <span
            class="ribbon-rec elevation-1"
            v-if="
              props.item.product_recommend && !props.item.product_best_seller
            "
            >{{ props.item.product_recommend ? "Recommend" : null }}</span
          >
          <span
            class="ribbon-best elevation-1"
            v-if="
              props.item.product_best_seller && !props.item.product_recommend
            "
            >{{ props.item.product_best_seller ? "Best seller" : null }}</span
          >
          <span style="position: absolute">
            <span
              class="ribbon-rec elevation-1"
              v-if="
                props.item.product_recommend && props.item.product_best_seller
              "
              >{{ props.item.product_recommend ? "Recommend" : null }}</span
            >
            <span
              class="ribbon-best elevation-1 mt-4"
              v-if="
                props.item.product_recommend && props.item.product_best_seller
              "
              >{{ props.item.product_best_seller ? "Best seller" : null }}</span
            >
          </span>
          <img :src="props.item.product_image" width="100px" height="100px" />
        </td>
        <td class="text-xs-left">
          {{ props.item.product_name_th }}
          <br />
          <span style="color: grey; font-size: 12px">{{
            props.item.product_name_en
          }}</span>
        </td>
        <td class="text-xs-center">
          {{ parseFloat(props.item.product_sale_price).toFixed(2) }}
        </td>
        <td class="text-xs-center">
          {{ parseFloat(props.item.product_base_price).toFixed(2) }}
        </td>
        <td class="text-xs-center">
          <v-switch
            :disabled="isEditProductList"
            @change="deActivate(props.item)"
            v-model="props.item.product_status"
            color="primary"
            class="mt-2"
            style="max-width: 50px"
          ></v-switch>
        </td>
        <td
          class="text-xs-center green--text"
          v-if="props.item.product_approve != 0"
        >
          {{ checkApprove(props.item) }}
        </td>
        <td
          style="padding: 0"
          v-else-if="
            props.item.product_approve == 0 || props.item.product_approve == 1
          "
        >
          {{ checkApprove(props.item) }}
          <v-btn
            small
            color="primary"
            class="black--text"
            @click="goOnline(props.item)"
            >go online</v-btn
          >
        </td>

        <td class="px-0">
          <v-tooltip bottom v-if="sort_data == false">
            <v-btn
              slot="activator"
              small
              icon
              :disabled="isEditProductList"
              @click="openHoldDialog(props.item)"
            >
              <v-icon small color="red darken-1">event_busy</v-icon>
            </v-btn>
            <span>close for a day</span>
          </v-tooltip>

          <v-btn
            small
            :disabled="dupplitcating_product || isEditProductList"
            :loading="dupplitcating_product"
            icon
            @click="
              dupplicateProduct(props.item, filterdProduct.indexOf(props.item))
            "
            v-if="sort_data == false"
          >
            <v-icon small>file_copy</v-icon>
          </v-btn>

          <v-btn
            small
            :to="
              '/weserve_admin_login/control/' +
              $store.state.backOffice.province +
              '/storeandproduct/store/' +
              $store.state.storeBack.store_detail_id +
              '/product/' +
              props.index +
              '/id/' +
              props.item.product_id
            "
            icon
            @click="editProduct(props.item, props.index)"
            v-if="sort_data == false"
          >
            <v-icon small>{{
              isEditProductList ? "remove_red_eye" : "edit"
            }}</v-icon>
          </v-btn>

          <v-btn
            small
            icon
            @click="delProductList(props.item)"
            :disabled="isEditProductList"
            v-if="sort_data == false"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center px-3" v-if="fetching == true">
          Loading ...
        </div>
        <label v-if="fetching == false">No data available</label>
        <br />
        <v-btn
          @click="initialize()"
          v-if="fetching == false && selected_type == 0"
          >Reset</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Sortable from "sortablejs";
import storeProductForm from "./StoreProductForm.vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    confirm_dialog_dup: false,
    confirm_dialog_del: false,
    dupplitcating_product: false,
    search_by_status: 99,
    selected_type: 0,
    enabled: true,
    data_for_sort: {},
    sort_data: false,
    sort_msg: 0,
    cancel_sort: false,
    sorting_data: false,
    search: "",
    fetching_data: false,
    original_data: null,
    form: null,
    fetching: false,
    productDialog: false,
    dialog: false,
    editedIndex: -1,
    hideActionsTable: false,
    productHoldDialog: false,
    holdLoading: false,
    holdSubmitting: false,
    holdRemovingIds: {},
    showInactiveHolds: false,
    holdDateMenu: false,
    selectedHoldProduct: null,
    productHolds: [],
    holdForm: {
      hold_date: moment().format("YYYY-MM-DD"),
      reason: "Call center ปิดชั่วคราว",
    },
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Product Code",
        align: "center",
        value: "product_code",
        sortable: false,
      },
      {
        text: "Image",
        align: "center",
        value: "img",
        sortable: false,
      },
      {
        text: "Product Name",
        align: "center",
        value: "product_name",
        sortable: false,
      },
      {
        text: "Sale Price",
        align: "center",
        value: "product_sale_price",
        sortable: false,
      },
      {
        text: "Base Price",
        align: "center",
        value: "product_base_price",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "product_status",
        sortable: false,
      },
      {
        text: "Approve",
        align: "center",
        value: "product_approve_name",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "action",
        sortable: false,
      },
    ],
  }),
  components: {
    draggable,
    storeProductForm,
  },
  computed: {
    ...mapState({
      store_name: (state) => state.storeBack.store_name,
      store_detail_id: (state) => state.storeBack.store_detail_id,
      product_type_list: (state) =>
        state.fetchProductTypeBack.product_type_list,
      product_list_pagination: (state) =>
        state.fetchProductListBack.product_list_pagination,
    }),
    ...mapGetters({
      product_list: "fetchProductListBack/productListTable",
      isEditProductList: "isEditProductList",
    }),
    filterdProduct() {
      if (this.search_by_status == 99) {
        return this.product_list;
      } else {
        return this.product_list.filter((value) => {
          return value.product_status == this.search_by_status;
        });
      }
    },

    holdRemoving() {
      return Object.values(this.holdRemovingIds).some((v) => v === true);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    showInactiveHolds() {
      if (this.productHoldDialog === true) {
        this.refreshHolds();
      }
    },
    pagination() {
      if (this.hideActionsTable == false) {
        this.$store.commit(
          "fetchProductListBack/setProductListPagination",
          this.pagination
        );
      }
    },
  },

  created() {
    this.initPageTable();
    this.setForm();
    this.initialize();
  },
  mounted() {
    let table = document.querySelector(".v-datatable tbody");
    const _self = this;
    Sortable.create(table, {
      handle: ".handle",
      onEnd({ oldIndex, newIndex }) {
        const rowSelected = _self.data_for_sort.product.splice(oldIndex, 1)[0];
        _self.data_for_sort.product.splice(newIndex, 0, rowSelected);
      },
    });
  },
  methods: {
    initPageTable() {
      this.pagination = JSON.parse(
        JSON.stringify(this.product_list_pagination)
      );
    },
    async deActivate(item) {
      let clone_item = JSON.parse(JSON.stringify(item));
      delete clone_item.product_approve_name;
      delete clone_item.product_image;
      let send_data = {
        product_id: clone_item.product_id,
        data: { product_status: clone_item.product_status },
      };
      const check_success = await this.$store.dispatch(
        "fetchProductListBack/deActivate",
        send_data
      );
      if (check_success == false) {
        item.product_status = !item.product_status;
      }
    },
    async dupplicateProduct(item, index) {
      let n = await this.$confirm("Do you want to duplicate this product ?");

      if (n == true) {
        this.dupplitcating_product = true;
        let product_detail = await this.$store.dispatch(
          "fetchProductListBack/getProductDetail",
          item.product_id
        );
        delete product_detail.product_id;
        for (let val of product_detail.product_option) {
          delete val.option_id;
          for (let val2 of val.option_choice) {
            delete val2.choice_id;
          }
        }
        if (product_detail.product_name_th != null) {
          product_detail.product_name_th =
            product_detail.product_name_th + "_copy";
        } else if (product_detail.product_name_en != null) {
          product_detail.product_name_en =
            product_detail.product_name_en + "_copy";
        } else if (product_detail.product_name_cn != null) {
          product_detail.product_name_cn =
            product_detail.product_name_cn + "_copy";
        }
        delete product_detail.product_image;
        product_detail.product_approve = 0;
        product_detail.product_status = false;
        let product_added = await this.$store.dispatch(
          "fetchProductListBack/addProductList",
          product_detail
        );
        this.$store.commit("fetchProductListBack/dupplicateProduct", {
          index,
          product_added,
        });

        let new_series = {};
        new_series.product_type = JSON.parse(
          JSON.stringify(this.product_type_list)
        );

        new_series.product = JSON.parse(JSON.stringify(this.product_list));
        let obj1 = await this.setSortData(new_series);
        await this.$store.dispatch(
          "fetchProductListBack/sortProductList",
          obj1
        );
        this.dupplitcating_product = false;
      }
    },
    countIndex(item) {
      return this.product_list.indexOf(item) + 1;
    },
    async filterType(type_id) {
      if (this.sort_data == false) {
        this.selected_type = type_id;
        if (type_id == 0) {
          this.fetching = true;
          await this.$store.dispatch("fetchProductListBack/getData");
          this.fetching = false;
        } else {
          this.fetching = true;
          await this.$store.dispatch(
            "fetchProductListBack/getProductByType",
            type_id
          );
          this.fetching = false;
        }
      }
    },
    async startSort() {
      this.hideActionsTable = true;
      this.pagination.rowsPerPage = -1;
      this.data_for_sort.product = JSON.parse(
        JSON.stringify(this.product_list)
      );
      this.sort_data = true;
    },
    async cancelSortData() {
      this.cancel_sort = true;

      await this.fetchNewData();
      this.cancel_sort = false;
      this.data_for_sort = {};
      this.sort_data = false;
      this.sort_msg = 0;
      this.hideActionsTable = false;
      this.pagination.rowsPerPage = 10;
      this.pagination.page = 1;
      this.$store.commit(
        "fetchProductListBack/setProductListPagination",
        this.pagination
      );
    },
    async setSortData(data) {
      let obj1 = JSON.parse(JSON.stringify(data));
      for (let key in obj1.product) {
        for (let x in obj1.product[key]) {
          if (x != "product_id" && x != "product_series") {
            delete obj1.product[key][x];
          }
        }
        obj1.product[key].product_series = parseFloat(key) + 1;
      }
      for (let key in obj1.product_type) {
        for (let x in obj1.product_type[key]) {
          if (x != "product_type_id" && x != "product_type_series") {
            delete obj1.product_type[key][x];
          }
        }
        obj1.product_type[key].product_type_series = parseFloat(key) + 1;
      }
      return obj1;
    },
    async saveSort() {
      this.sorting_data = true;
      this.data_for_sort.product_type = JSON.parse(
        JSON.stringify(this.product_type_list)
      );
      let obj1 = await this.setSortData(this.data_for_sort);
      this.sort_msg = await this.$store.dispatch(
        "fetchProductListBack/sortProductList",
        obj1
      );
      if (this.sort_msg != 3) {
        await this.fetchNewData();
        this.sort_data = false;
        this.hideActionsTable = false;
      }
      this.sorting_data = false;
    },
    addProduct() {
      this.setForm();
    },
    toAdd() {
      this.setForm();
      // this.productDialog = true;
    },
    setForm() {
      this.form = {
        product_code: null,
        product_image: null,
        product_name_th: null,
        product_description_th: null,
        product_name_en: null,
        product_description_en: null,
        product_name_cn: null,
        product_description_cn: null,
        product_sale_price: null,
        product_base_price: null,
        product_note: null,
        product_type_id: null,
        product_recommend: false,
        product_best_seller: false,
        product_approve: 0,
        product_status: false,
        product_store_id: this.store_detail_id,
        product_option: [],
      };
    },
    async delProductList(item) {
      let n = await this.$confirm("Do you want to delete this product ?");
      if (n == true) {
        this.$store.dispatch("fetchProductListBack/delProductList", item);
      }
    },
    goOnline(item) {
      this.$store.dispatch("fetchProductListBack/onWebProduct", item);
    },
    checkApprove(item) {
      if (item.product_approve == 1) {
        item.product_approve_name = "Pending";
      } else if (item.product_approve == 2) {
        item.product_approve_name = "Online";
      } else if (item.product_approve == 0) {
        item.product_approve_name = "Offline";
      }
      return item.product_approve_name;
    },
    async fetchNewData() {
      this.fetching = true;
      this.$store.commit("fetchProductTypeBack/getData", []);
      this.$store.commit("fetchProductListBack/getData", []);
      this.$store.dispatch("fetchProductTypeBack/getData");
      await this.$store.dispatch("fetchProductListBack/getData");
      this.fetching = false;
    },
    async initialize() {
      this.fetching = true;
      if (this.store_detail_id == null) {
        let store_detail = await this.$store.dispatch(
          "fetchStoreBack/getStoreDetail",
          this.$route.params.store_id
        );
        this.$store.commit(
          "storeBack/setStoreDetailId",
          store_detail.store.store_id
        );
      }
      this.$store.dispatch("fetchProductTypeBack/getData");
      await this.$store.dispatch("fetchProductListBack/getData");
      this.fetching = false;
    },
    async editProduct(item, index) {
      // this.form = {};
      this.editedIndex = index;
      // this.fetching_data = true;
      // let get_data = await this.$store.dispatch(
      //   "fetchProductListBack/getProductDetail",
      //   item.product_id
      // );
      // this.fetching_data = false;
      // this.original_data = Object.assign({}, get_data);
      // this.form = get_data;
    },

    openHoldDialog(product) {
      this.selectedHoldProduct = product;
      this.productHoldDialog = true;
      this.holdForm.hold_date = moment().format("YYYY-MM-DD");
      this.holdForm.reason = "Call center ปิดชั่วคราว";
      this.refreshHolds();
    },

    closeHoldDialog() {
      if (this.holdSubmitting || this.holdRemoving) return;
      this.productHoldDialog = false;
      this.selectedHoldProduct = null;
      this.productHolds = [];
      this.holdRemovingIds = {};
      this.showInactiveHolds = false;
    },

    async refreshHolds() {
      if (!this.selectedHoldProduct) return;
      this.holdLoading = true;
      try {
        const res = await this.$store.dispatch(
          "fetchProductListBack/getProductHolds",
          {
            product_id: this.selectedHoldProduct.product_id,
            active: this.showInactiveHolds ? null : true,
            limit: 50,
          }
        );
        if (res === false) {
          this.productHolds = [];
          return;
        }

        // API shape from docs: { msg: true, data: [...], count: n }
        const list = res && res.data ? res.data : res;
        this.productHolds = Array.isArray(list) ? list : [];
      } finally {
        this.holdLoading = false;
      }
    },

    async submitHold() {
      if (!this.selectedHoldProduct) return;
      const confirmText =
        "Confirm hold product for this date?" +
        `\n${this.selectedHoldProduct.product_name_th || ""}` +
        `\nDate: ${this.holdForm.hold_date}`;
      const ok = await this.$confirm(confirmText);
      if (ok !== true) return;

      this.holdSubmitting = true;
      try {
        const res = await this.$store.dispatch(
          "fetchProductListBack/holdProductForDate",
          {
            product_id: this.selectedHoldProduct.product_id,
            hold_date: this.holdForm.hold_date,
            reason: this.holdForm.reason,
          }
        );
        if (res === false) {
          alert("Unable to hold product");
          return;
        }

        const created = res && res.data ? res.data.created : undefined;
        if (created === false) {
          alert("Already held for this date");
        } else {
          alert("Product held successfully");
        }

        await this.refreshHolds();
      } catch (e) {
        alert("Unable to hold product");
      } finally {
        this.holdSubmitting = false;
      }
    },

    async removeHold(hold) {
      console.log(hold);

      const ok = await this.$confirm(
        `Remove hold on ${hold.start_date}?` +
          (hold.reason ? `\nReason: ${hold.reason}` : "")
      );
      if (ok !== true) return;

      this.$set(this.holdRemovingIds, hold.product_hold_id, true);
      try {
        const res = await this.$store.dispatch(
          "fetchProductListBack/removeProductHold",
          {
            product_id: hold.product_id,
            hold_date: hold.start_date,
            province: this.$route.params.province,
          }
        );
        if (res === false) {
          alert("Unable to remove hold (check backend endpoint)");
          return;
        }
        await this.refreshHolds();
      } catch (e) {
        alert("Unable to remove hold");
      } finally {
        this.$set(this.holdRemovingIds, hold.product_hold_id, false);
      }
    },
  },
};
</script>
<style scoped>
.product-hold-card {
  border-radius: 16px;
  overflow: hidden;
}

.product-hold-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #fddf00 0%, #f39c12 100%);
  gap: 1rem;
}

.header-icon {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-content {
  flex: 1;
  min-width: 0;
}

.header-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: black;
  margin: 0;
}

.header-subtitle {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.8);
  margin: 0.25rem 0 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-btn {
  background: rgba(0, 0, 0, 0.1) !important;
  color: black !important;
}

.product-hold-content {
  padding: 2rem;
  max-height: 70vh;
  overflow-y: auto;
}

.hold-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

.hold-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
}

.section-header {
  margin-bottom: 1rem;
}

.section-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

.form-field {
  margin-bottom: 1rem;
}

.action-btn {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}

.hold-btn {
  color: black !important;
}

.refresh-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
}

.hold-history-list {
  background: transparent;
}

.hold-history-item {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
  padding: 0.25rem 0.5rem;
  margin-bottom: 0.5rem;
}

.product-hold-actions {
  padding: 1rem 2rem 1.5rem;
  background: #f8f9fa;
  border-top: 1px solid #e5e7eb;
  gap: 1rem;
}

.close-action-text {
  color: white !important;
}

/* Mobile */
@media (max-width: 768px) {
  .product-hold-header {
    padding: 1rem 1.5rem;
  }

  .product-hold-content {
    padding: 1.5rem;
  }

  .hold-grid {
    grid-template-columns: 1fr;
  }

  .hold-section {
    padding: 1rem;
  }

  .product-hold-actions {
    padding: 1rem 1.5rem;
    flex-direction: column;
  }

  .product-hold-actions .action-btn {
    width: 100%;
  }
}

.ribbon-rec {
  background-color: rgba(255, 255, 255, 0.817);
  color: black;
  padding: 1px 5px;
  margin-top: 3px;
  position: absolute;
  border-radius: 0px 2px 2px 0px;
}
.ribbon-best {
  background-color: #ffd500c2;
  color: black;
  padding: 1px 5px;
  margin-top: 3px;
  position: absolute;
  width: 70px;
  border-radius: 0px 2px 2px 0px;
}
</style>


